import { Component } from '@angular/core';

@Component({
    selector: 'register',
    templateUrl: 'register.template.html'
})
export class registerComponent { }


// WEBPACK FOOTER //
// ./src/app/views/register/register.component.ts